import { api } from "./instance";

// Тип для объектов с кодом и текстом (роли, статусы)
export interface DictionaryItem {
  code: string;
  label: string;
}

// Специфичный тип для багажа
export interface BaggagePreset {
  carryOnKg: number;
  checkedKg: number;
  label: string;
}

// Полная структура вашего словаря из JSON
export interface SystemDictionary {
  airlines: string[];
  baggage_presets: BaggagePreset[];
  cabin_classes: string[];
  countries: string[];
  currencies: string[];
  departure_time_slots: string[];
  employee_roles: DictionaryItem[];
  employee_statuses: DictionaryItem[];
  fare_types: string[];
  flight_statuses: string[];
  flight_types: DictionaryItem[];
  markup_types: string[];
  payment_statuses: DictionaryItem[];
  order_statuses: DictionaryItem[];
}

// Поскольку API возвращает словарь внутри объекта { data: ... }
export interface DictionaryApiResponse {
  data: SystemDictionary;
}

export const getFilters = async (): Promise<SystemDictionary> => {
  const response = await api.get<DictionaryApiResponse>("/api/v1/dictionary");

  return response.data.data;
};

interface LocalizedString {
  ru: string;
  en: string;
  kz: string;
}

interface AndromedaRef {
  id: number;
  cityId: number;
  countryId: number;
}

export interface Airport {
  ID: number;
  IATA: string;
  Name: LocalizedString;
  City: LocalizedString;
  Country: LocalizedString;
  Timezone: string;
  AndromedaRef: AndromedaRef;
  CreatedAt: string;
  UpdatedAt: string;
}

// Если бэк возвращает массив:
export type AirportsResponse = { data: Airport[] };

export const getAirports = async (): Promise<Airport[]> => {
  const response = await api.get<AirportsResponse>("/api/v1/airport");

  return response.data.data;
};
